export default __webpack_public_path__ + "static/1639-a3b083fc25c93c324487dd2a7f74d207.gif";